/* product-hero-r45.js — the resin hero, rounds 45/46/47. PRESENTATION ONLY.
   The money path (add to cart, availability, sold-out truth, re-entrancy)
   belongs to assets/pdp-atc.js and is not duplicated here. This file owns:

     1. wiring and painting the desktop buy bar's button, which is the one add
        control pdp-atc.js does not own;
     2. the chosen-box and chosen-mode classes;
     3. the figures that follow the chosen box (receipt, mobile price, the two
        prices inside the "how it comes" card, both sticky bars);
     4. the gallery;
     5. the two sticky bars.

   It owns NO money path. The add itself, the sold-out truth and the one-add
   guard all live elsewhere, so that this file failing to load can never change
   what a shopper is charged — only how much of the page moves.

   The chosen state is an explicit `.on` class rather than :has(input:checked)
   alone. The CSS carries both, but script-set state does not repaint :has() in
   some older Safari builds — the round-11 finding on the bundle pages. The two
   rules can never disagree, because .on is set from the same :checked. */
(function () {
  var scope = document.querySelector('.r45');
  if (!scope) return;

  /* ── 1 · the one-add guard is NOT here ───────────────────────────────────
     It used to be, and it was wrong. Cancelling the form's native submit from
     this file meant the cancel was unconditional and it depended on this asset
     loading — so `pdp-atc.js ✓ + this ✗` added twice, and `pdp-atc.js ✗ +
     this ✓` added nothing at all. The guard now lives in a small inline script
     directly under the form in sections/product-hero-r45.liquid, where it
     parses before either asset can fail and tests for window.SacrasoulPdpAdd
     at submit time. Read the comment there before touching either. */

  /* ── 2/3 · the size boxes and everything that follows a price ──────────── */
  var packs = scope.querySelector('#packs');
  var receiptSize = scope.querySelector('[data-r45-receipt-size]');
  var receiptPrice = scope.querySelector('[data-r45-receipt-price]');
  var mPrice = scope.querySelector('[data-r45-mprice]');
  var mSize = scope.querySelector('[data-r45-msize]');
  var oncePrice = scope.querySelector('[data-r45-once-price]');
  var subPrice = scope.querySelector('[data-r45-sub-price]');
  var barPrices = scope.querySelectorAll('[data-r45-bar-price]');
  var barSizes = scope.querySelectorAll('[data-r45-bar-size]');
  var atcBtn = scope.querySelector('#atc');

  /* ── the desktop bar button ──────────────────────────────────────────────
     pdp-atc.js owns #atc, [data-sticky-add], .offer [data-atc] and
     [data-kq-add], and that list is closed (assets/pdp-atc.js:36, :233-235).
     [data-r45-bar-add] is in none of them, so it was a button that painted
     nothing and did nothing when clicked. It is this file's to wire.

     It FORWARDS to #atc rather than calling window.SacrasoulPdpAdd itself.
     That is the point: #atc already carries the whole money path and the
     inline one-add guard, so every load outcome stays exactly one add —
     with pdp-atc.js up the forwarded click fetches and the guard cancels the
     submit; with pdp-atc.js down the forwarded click submits the form
     natively. A second direct call to SacrasoulPdpAdd would have been a
     second money path to keep in step, and money paths do not stay in step. */
  var barAdd = document.querySelector('[data-r45-bar-add]');
  /* Captured only when the page did NOT render sold out. Reading it in the
     sold-out state would bank the "Sold out" word as the live label and print
     it back over a button that had come alive again. */
  var barLiveLabel = (barAdd && !barAdd.hasAttribute('data-sold-out')) ? barAdd.textContent : '';

  function barSold() {
    /* #atc is the single source of truth for availability. pdp-atc.js writes
       both of these on it via __ssPaintControl. */
    if (!atcBtn) return false;
    return atcBtn.disabled || atcBtn.hasAttribute('data-sold-out');
  }

  function paintBar() {
    if (!barAdd || !atcBtn) return;
    var sold = barSold();
    barAdd.disabled = sold;
    if (sold) {
      barAdd.setAttribute('data-sold-out', 'true');
      barAdd.setAttribute('aria-disabled', 'true');
      barAdd.textContent = atcBtn.getAttribute('data-soldout-label') || barAdd.textContent;
    } else {
      barAdd.removeAttribute('data-sold-out');
      barAdd.removeAttribute('aria-disabled');
      if (barLiveLabel) barAdd.textContent = barLiveLabel;
    }
  }

  if (barAdd) {
    barAdd.addEventListener('click', function (e) {
      e.preventDefault();
      if (barSold()) return;
      if (atcBtn) atcBtn.click();
    });
  }
  /* Both assets are `defer`, so they execute in document order: pdp-atc.js has
     already run its own __ssRefreshAddState() by the time this line does, and
     #atc is painted. Paint once here rather than relying on renderPacks(),
     which returns early if #packs is ever absent. */
  paintBar();

  /* ── sold out: the sign-up stands in for the dead buttons (2026-10-06) ───
     #atc's sold-out state (written by Liquid, then by pdp-atc.js) decides
     which face the buy area wears. Sold: #atc, the mobile bar's add and the
     desktop bar's add step aside, and the notify host (state line + morph,
     assets/pdp-notify.js) and the two bars' notify buttons take their place.
     Liquid renders the same split server-side, so this only matters when the
     truth changes mid-visit: Shopify refuses the chosen size with a 422 and
     pdp-atc.js marks it dead. The morph is then pointed at THAT size. */
  var notifyHost = scope.querySelector('#r45-notify');
  var stickyAdd = scope.querySelector('[data-sticky-add]');
  var barNotifies = scope.querySelectorAll('[data-r45-bar-notify]');
  var wasSold = scope.classList.contains('r45--soldout');
  /* An in-stock render leaves every sold-out word empty, its text parked in
     data-fill-label (sections/product-hero-r45.liquid: a hidden "Sold out" is
     still text to a crawler). Write them back before any of them is shown. */
  function fillLabels(root) {
    var els = root.querySelectorAll('[data-fill-label]');
    for (var i = 0; i < els.length; i++) {
      if (!els[i].textContent) els[i].textContent = els[i].getAttribute('data-fill-label');
    }
  }
  function syncSoldOut() {
    var sold = barSold();
    if (sold === wasSold) return;
    wasSold = sold;
    if (sold) fillLabels(scope);
    scope.classList.toggle('r45--soldout', sold);
    if (atcBtn) atcBtn.hidden = sold;
    if (barAdd) barAdd.hidden = sold;
    if (stickyAdd) stickyAdd.hidden = sold;
    for (var i = 0; i < barNotifies.length; i++) barNotifies[i].hidden = !sold;
    if (!notifyHost) return;
    if (sold) {
      var r = packs && packs.querySelector('input:checked');
      var vid = (window.__ssPick && window.__ssPick['resin-r45']) || (r && r.getAttribute('data-vid'));
      if (r && vid && String(r.getAttribute('data-vid')) !== String(vid)) {
        r = packs.querySelector('input[data-vid="' + String(vid).replace(/["\\]/g, '') + '"]') || r;
      }
      if (vid) notifyHost.setAttribute('data-notify-variant-id', vid);
      var size = r && r.getAttribute('data-size');
      if (size) notifyHost.setAttribute('data-notify-variant', size);
      notifyHost.hidden = false;
      if (window.SSPdpNotify) window.SSPdpNotify.context(notifyHost);
    } else {
      notifyHost.hidden = true;
    }
  }
  if (atcBtn) new MutationObserver(syncSoldOut).observe(atcBtn, { attributes: true, attributeFilter: ['disabled', 'data-sold-out'] });
  syncSoldOut();

  function setAll(list, text) {
    for (var i = 0; i < list.length; i++) list[i].textContent = text;
  }

  function renderPacks() {
    if (!packs) return;
    var boxes = packs.querySelectorAll('.r45-box');
    var checked = null;
    for (var i = 0; i < boxes.length; i++) {
      var input = boxes[i].querySelector('input');
      var on = !!(input && input.checked);
      boxes[i].classList.toggle('on', on);
      if (on) checked = input;
    }
    /* Before the early return: availability has to repaint even in the state
       where nothing is checked because everything is sold out. pdp-atc.js binds
       `change` on each radio and this handler sits on the #packs container, so
       target-phase runs first and #atc is already repainted by the time we read
       it here. */
    paintBar();
    if (!checked) return;
    var price = checked.getAttribute('data-price');
    var size = checked.getAttribute('data-size');
    /* #atcprice is pdp-atc.js's to write and it already does on the same
       event; everything below is this page's own furniture. */
    if (receiptPrice && price) receiptPrice.textContent = price;
    if (receiptSize && size) receiptSize.textContent = size;
    if (mPrice && price) mPrice.textContent = price;
    if (mSize && size) mSize.textContent = size;
    if (oncePrice && price) oncePrice.textContent = price;
    /* Liquid renders this card only while the live successor allocations are
       the same price as the selected one-time variant. The size picker mirrors
       that verified equality; a differently priced group fails closed. */
    if (subPrice && price) subPrice.textContent = price;
    if (price) setAll(barPrices, price);
    if (size) setAll(barSizes, size);
  }
  if (packs) packs.addEventListener('change', renderPacks);
  /* iOS Safari paints :active only where a touch listener exists; a passive
     no-op is enough for the press feedback in product-hero-r45.css. */
  if (packs) packs.addEventListener('touchstart', function () {}, { passive: true });
  renderPacks();

  // Remember this choice during a kit comparison, but never override a product link
  // with an explicit variant or restore a variant that is now unavailable.
  if (packs && document.querySelector('[data-purchase-recap]')) {
    var choiceKey = 'ss_resin_choice:' + location.pathname.split('/products/')[1];
    try {
      var saved = sessionStorage.getItem(choiceKey);
      if (saved && !new URLSearchParams(location.search).has('variant')) {
        var remembered = Array.from(packs.querySelectorAll('input')).find(function (r) {
          return !r.disabled && String(r.getAttribute('data-vid') || r.value) === saved;
        });
        if (remembered) {
          remembered.checked = true;
          remembered.dispatchEvent(new Event('change', {bubbles:true}));
        }
      }
    } catch (_) { /* Storage is optional; native selection still works. */ }
    packs.addEventListener('change', function () {
      var selected = packs.querySelector('input:checked');
      if (!selected || selected.disabled) return;
      try { sessionStorage.setItem(choiceKey, selected.getAttribute('data-vid') || selected.value); } catch (_) {}
    });
  }

  // Purchase controls after proof share the hero's variant and add path.
  var recaps = Array.from(document.querySelectorAll('[data-purchase-recap]'));
  function syncRecaps() {
    var chosen = packs && packs.querySelector('input:checked');
    recaps.forEach(function (recap) {
      var select = recap.querySelector('[data-recap-size]');
      if (chosen && select) select.value = chosen.getAttribute('data-vid') || chosen.value;
      var add = recap.querySelector('[data-recap-add]');
      if (add && atcBtn) {
        add.disabled = atcBtn.disabled || atcBtn.hasAttribute('data-sold-out');
        if (!add.dataset.liveLabel) add.dataset.liveLabel = add.textContent;
        add.textContent = atcBtn.hasAttribute('data-sold-out') ? atcBtn.getAttribute('data-soldout-label') || add.dataset.liveLabel : add.dataset.liveLabel;
      }
    });
  }
  if (packs && atcBtn) {
    recaps.forEach(function (recap) {
      recap.querySelector('[data-recap-controls]').hidden = false;
      recap.querySelector('[data-recap-fallback]').hidden = true;
      recap.querySelector('[data-recap-size]').addEventListener('change', function () {
        var id = this.value;
        var radio = Array.from(packs.querySelectorAll('input')).find(function (r) { return String(r.getAttribute('data-vid') || r.value) === id; });
        if (!radio || radio.disabled) { syncRecaps(); return; }
        radio.checked = true;
        radio.dispatchEvent(new Event('change', {bubbles:true}));
      });
      recap.querySelector('[data-recap-add]').addEventListener('click', function () {
        recap.querySelector('[data-recap-status]').textContent = '';
        if (!atcBtn.disabled) atcBtn.click();
      });
    });
    document.addEventListener('sacrasoul:cart-add-failed', function () {
      recaps.forEach(function (recap) {
        recap.querySelector('[data-recap-status]').textContent = recap.getAttribute('data-retry-label') || '';
      });
    });
    packs.addEventListener('change', syncRecaps);
    new MutationObserver(syncRecaps).observe(atcBtn, {attributes:true,attributeFilter:['disabled','data-sold-out']});
    syncRecaps();
  }

  /* ── the "how it comes" card ───────────────────────────────────────────
     Visual state only. The live selling-plan id stays on the checked frequency
     control and pdp-atc.js reads it at the instant the shopper adds. */
  var modes = scope.querySelector('.r45-modes');
  if (modes) {
    modes.addEventListener('change', function () {
      var rows = modes.querySelectorAll('.r45-mode');
      for (var i = 0; i < rows.length; i++) {
        var input = rows[i].querySelector('input');
        rows[i].classList.toggle('on', !!(input && input.checked));
      }
    });
  }

  /* ── 4 · the gallery ─────────────────────────────────────────────────────
     The new frame is decoded BEFORE it is shown, so a swap never flashes a
     half-painted image; the main frame answers a swipe and the arrow keys; a
     frame that fails to load retries twice rather than leaving a blank
     rectangle. A reader who has asked for less motion gets the swap with no
     fade at all. */
  var main = scope.querySelector('[data-r45-main]');
  var counter = scope.querySelector('[data-r45-counter]');
  var thumbs = [].slice.call(scope.querySelectorAll('[data-r45-thumb]'));
  var strip = scope.querySelector('.r45-thumbs');
  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── THE POSITION RAIL ────────────────────────────────────────────────────
     The counter used to be one text node that this function rewrote whole, and
     it read its own total back out of itself — "2 / " + textContent.split('/')
     — so the total survived only as long as nothing else ever wrote the node.
     It is the tool gallery's rail now (snippets/pdp-gallery-rail): a padded
     index, a total that is never re-parsed because it is never rewritten, and
     a filled segment that steps one frame at a time. Same contract as
     assets/product-hero.js:railSet, deliberately. */
  var railEl = counter;
  var railCur = railEl && railEl.querySelector('[data-rail-current]');
  var railFill = railEl && railEl.querySelector('[data-rail-fill]');
  var railLive = railEl && railEl.querySelector('[data-rail-live]');
  var railTotal = railEl ? (+railEl.getAttribute('data-gallery-count') || thumbs.length) : thumbs.length;
  var railTimer = null;

  function railPad(n) { return n < 10 ? '0' + n : String(n); }

  function railSet(i, label) {
    if (!railEl || railTotal < 2) return;
    var n = +label || (i + 1);
    if (n < 1) n = 1;
    if (n > railTotal) n = railTotal;
    if (railCur) railCur.textContent = railPad(n);
    if (railFill) railFill.style.transform = 'translateX(' + ((n - 1) * 100) + '%)';
    /* One announcement behind a swipe through five frames, not five. */
    if (railLive) {
      clearTimeout(railTimer);
      railTimer = setTimeout(function () {
        var t = railEl.getAttribute('data-gallery-announce') || 'Image {index} of {total}';
        railLive.textContent = t.replace('{index}', String(n)).replace('{total}', String(railTotal));
      }, 350);
    }
  }
  var cur = 0;

  /* A press held before boot is shown by marking its thumbnail
     (snippets/gallery-preboot-tap); take that back before reading the marked
     thumbnail, or the replayed press would count from the wrong frame. */
  if (typeof window.__ssGalleryRestore === 'function') window.__ssGalleryRestore();
  for (var t = 0; t < thumbs.length; t++) {
    if (thumbs[t].getAttribute('aria-current') === 'true') { cur = t; break; }
  }

  function guard(img) {
    if (!img || img.__g) return;
    img.__g = 1;
    img.addEventListener('error', function () {
      var r = +(img.getAttribute('data-gr') || 0);
      if (r >= 2) { img.style.opacity = ''; return; }
      img.setAttribute('data-gr', r + 1);
      var src = img.getAttribute('src');
      setTimeout(function () { img.setAttribute('src', src); }, 220 * (r + 1));
    });
  }
  guard(main);

  /* Each tap is acknowledged at once and the photograph follows.

     The old shape gated everything on the full-size decode: while `busy`, a
     tap only queued cur+1, and cur did not move until the swap. Five quick
     taps on a slow connection therefore queued the SAME index five times and
     moved one image; PostHog recorded them as rage clicks on the gallery
     arrows (replays 6 Sep, Chrome Android and Facebook iOS, both at 8/8).
     Now the index, the counter and the marked thumbnail advance on the tap
     itself, and the image swaps when its decode lands. A decode slower than
     SWAP_GRACE_MS is not waited for: the src is set anyway and the browser
     paints it progressively. Only the newest request may swap; a stale decode
     arriving late is ignored. */
  var SWAP_GRACE_MS = 350;
  var seq = 0;
  var lastPre = null;
  /* A superseded request must stop downloading, or five quick taps on a slow
     connection leave five full-size fetches sharing the one pipe the newest
     frame needs. Emptying src on the abandoned Image releases it. */
  function dropPre(pre) {
    if (!pre) return;
    try { pre.onload = pre.onerror = null; pre.srcset = ''; pre.src = ''; } catch (e) {}
  }
  function mark(i, b) {
    for (var k = 0; k < thumbs.length; k++) thumbs[k].setAttribute('aria-current', k === i ? 'true' : 'false');
    /* The strip is one scrolling row now, so the arrows have to bring the
       active thumbnail with them — otherwise pressing next on image four
       moves the photograph and leaves the marked tile off the right edge.

       The strip's OWN scrollLeft, never scrollIntoView. `block: 'nearest'`
       sounds safe and is not: when the rail itself is partly below the fold —
       which it is on a phone the moment you have read past the photograph —
       the browser satisfies "nearest" by scrolling the DOCUMENT, and pressing
       a gallery arrow jerks the whole page. Moving the rail's own scroll
       offset can only ever move the rail. (GPT caught this on review; the
       live gallery in assets/product-hero.js avoids scrollIntoView for the
       same reason.) */
    if (strip && strip.scrollWidth > strip.clientWidth + 1) {
      var want = b.offsetLeft - (strip.clientWidth - b.offsetWidth) / 2;
      want = Math.max(0, Math.min(want, strip.scrollWidth - strip.clientWidth));
      if (strip.scrollTo) strip.scrollTo({ left: want, behavior: still ? 'auto' : 'smooth' });
      else strip.scrollLeft = want;
    }
    railSet(i, b.getAttribute('data-index'));
  }
  /* Warm the frames on either side of the one being read.

     Without this the download of the next photograph started AT the tap. On a
     throttled phone the counter flipped to "2 / 14" in 19ms and the picture
     followed 7.0 seconds later (measured live on sacred-myrrh, 2026-09-10):
     the gallery said it had moved and the eye said it had not, which is what a
     rage click is. Frames 1, 2, 11 and 12 on three of the five resin pages are
     PNG masters that Shopify's CDN hands to Safari unconverted, ~1 MB each
     against 105 KB of WebP for the same URL on Chrome, so the wait is worst
     exactly where it is most likely to be met.

     This is product-first-flame-r13.js's warm(), which has been in production
     since the r13 gallery shipped. Copied deliberately rather than shared: the
     two engines keep separate thumb attributes and separate sizes strings. */
  var GALLERY_SIZES = main ? main.sizes : '';
  /* THE RUNG (2026-09-23). The lead frame keeps the section's own sizes, so it
     stays the LCP image it already is. Every other frame is asked for at a
     phone-capped width: 260px at 2.5x and denser (780 device px -> the 800
     rung), 100vw below that (a DPR-2 phone also lands on 800). The section's
     100vw alone sent a DPR-3 phone the top rung, 1080-1200 px for a 358px box,
     which is what made the first Next on sacred-myrrh take 9 s on slow 4G.
     Desktop keeps the section's sizes past 430px, so the full view stays sharp;
     product-gallery-zoom.js opens data-full (the top rung) regardless. */
  var SWAP_SIZES = '(max-width: 430px) and (min-resolution: 2.5dppx) 260px, ' + GALLERY_SIZES;
  var LEAD = cur;
  function sizesFor(i) { return i === LEAD ? GALLERY_SIZES : SWAP_SIZES; }
  /* One Image per frame, kept, so a warmed frame is found decoded. */
  var cache = {};
  function frame(i) {
    var b = thumbs[i];
    if (!b) return null;
    /* A frame whose fetch failed is not reused: a flaky line drops one request,
       and the next tap must fetch it again rather than find the broken Image. */
    var c = cache[i];
    if (c && !(c.complete && !c.naturalWidth)) return c;
    var im = new Image();
    im.decoding = 'async';
    if (b.getAttribute('data-full-srcset')) {
      im.sizes = sizesFor(i);
      im.srcset = b.getAttribute('data-full-srcset');
    }
    im.src = b.getAttribute('data-full');
    cache[i] = im;
    return im;
  }
  /* Warm the frames ahead, and never while a tap is in flight: the warm must
     not share a slow pipe with the frame the reader asked for. This replaces
     the old walk over every frame (one per idle callback), which on slow 4G
     queued thirteen full-size downloads in front of the first tap. */
  /* Kept two frames ahead of the one on screen (i+1 and i+2), started only
     while no tap is in flight: at `load`, and each time a tapped frame lands.
     A warm therefore never starts against the frame the reader asked for.
     Two, not one: a second Next pressed straight after the first found i+2
     cold (measured, see the PR). */
  var busy = false;
  function warm(i) {
    var c = (typeof navigator !== 'undefined' && navigator.connection) || {};
    if (busy || c.saveData === true) return;
    for (var k = i + 1; k <= i + 2 && k < thumbs.length; k++) frame(k);
  }
  function warmSoon() { warm(cur); }
  /* Frame i fetched WITHOUT holding window load (2026-10-31). frame()'s
     new Image() is a document image fetch, and Chromium and Firefox hold
     `load` until it lands; started at the hero's load (#3522) it pushed `load`
     on terracotta-burner from 5.3 s to 6.1 s (Chromium, 4x CPU, 1.6 Mbps /
     150 ms), and snippets/gtm-loader starts the tags at `load` for a visitor
     who has not touched the page. A <link rel=preload as=image> goes out with
     the image Accept header (the CDN varies on it; a plain fetch() came back
     as a JPEG and was fetched again), holds `load` in none of Chromium,
     Firefox and WebKit, and frame(i) is then served from it with no second
     request (tests/browser/gallery-warm-keeps-load-proof.mjs). Same srcset and
     sizesFor(i) as frame(), so the same rung; skipped where the browser cannot
     preload by srcset, which would fetch data-full, the wrong rung. */
  function early(i) {
    var b = thumbs[i];
    if (!b || cache[i] || b.__e) return;
    var l = document.createElement('link'), ss = b.getAttribute('data-full-srcset');
    if (!(l.relList && l.relList.supports && l.relList.supports('preload'))) return;
    if (ss && !('imageSrcset' in l)) return;
    b.__e = 1;
    l.rel = 'preload'; l.as = 'image'; l.setAttribute('fetchpriority', 'low');
    if (ss) { l.setAttribute('imagesrcset', ss); l.setAttribute('imagesizes', sizesFor(i)); }
    l.href = b.getAttribute('data-full');
    document.head.appendChild(l);
  }

  function show(i) {
    if (!main || !thumbs.length) return;
    if (i < 0) i = thumbs.length - 1;
    if (i >= thumbs.length) i = 0;
    var b = thumbs[i];
    var next = b.getAttribute('data-full');
    if (!next) return;
    cur = i;
    mark(i, b);
    var mine = ++seq;
    var done = false;
    busy = true;
    /* A superseded, still-downloading frame is dropped (and forgotten, so it
       is fetched afresh if asked for again): five quick taps must not leave
       five downloads sharing the pipe the newest frame needs. */
    if (lastPre && lastPre.i !== i && !lastPre.im.complete) { dropPre(lastPre.im); delete cache[lastPre.i]; }
    var pre = frame(i);
    lastPre = { i: i, im: pre };
    /* SOMETHING ON SCREEN AT THE TAP. If the frame is not in hand, the tapped
       thumbnail -- on screen, so already decoded -- goes up in the photo box at
       once; the full frame replaces it when it lands. */
    if (!(pre.complete && pre.naturalWidth)) {
      var ti = b.querySelector('img');
      /* srcset to the thumb, then src (2026-11-01). Clearing srcset first made
         WebKit, which starts a fetch on every srcset/src write, fall back to the
         src attribute and download the frame on screen again at its top rung
         (terracotta-burner: a 1200w PNG on the first cold tap, sharing the pipe
         with the frame the reader asked for). Same order as r13 commit(). */
      if (ti && ti.complete && ti.naturalWidth) { var tu = ti.currentSrc || ti.src; main.srcset = tu; main.src = tu; }
    }
    var landed = false;
    var swap = function () {
      if (done || mine !== seq) return;
      done = true;
      clearTimeout(grace);
      main.sizes = sizesFor(i);
      main.srcset = b.getAttribute('data-full-srcset') || '';
      main.src = next;
      main.alt = b.getAttribute('data-full-alt') || '';
      /* The dissolve only when the frame is decoded and paints on this line.
         On the grace path the browser keeps showing the old frame until the
         bytes land, so a dip here would flicker the wrong photograph; the new
         one then cuts in when it arrives, which is the honest ending. */
      if (landed && !still) { main.style.opacity = '0'; requestAnimationFrame(function () { main.style.opacity = ''; }); }
    };
    var grace = setTimeout(swap, SWAP_GRACE_MS);
    var onDecoded = function () {
      if (mine !== seq) return;
      landed = true; busy = false; swap(); warmSoon();
    };
    /* Bytes first, then the decode: a decode() called right after sizes, srcset
       and src were set is rejected by the superseded image update and used to
       "land" a frame that had not arrived (traced 2026-09-23). */
    var ready = function () { if (pre.decode) pre.decode().then(onDecoded).catch(onDecoded); else onDecoded(); };
    if (pre.complete && pre.naturalWidth) ready();
    else { pre.addEventListener('load', ready, { once: true }); pre.addEventListener('error', onDecoded, { once: true }); }
  }

  for (var n = 0; n < thumbs.length; n++) {
    (function (i) { thumbs[i].addEventListener('click', function () { show(i); }); })(n);
  }

  /* The very first "next" is the one that has nothing behind it, so warm frame
     two once the page is done loading -- after the LCP hero has had the
     connection to itself, never against it. Not on a metered connection: this
     can be a megabyte for a frame the reader may never open, which is the same
     refusal product-first-flame-r13.js and bundle-ritual-films.js make. */
  var conn = (typeof navigator !== 'undefined' && navigator.connection) || {};
  var scarce = conn.saveData === true || /(^|-)2g$/.test(conn.effectiveType || '');
  var warmFirst = function () {
    if (scarce) return;
    /* The thumbnail strip stops being lazy: a few KB each, and they are the
       instant placeholder show() puts up. At load, not earlier: Firefox holds
       `load` for a lazy image flipped to eager. */
    if (strip) [].slice.call(strip.querySelectorAll('img[loading="lazy"]')).forEach(function (im) { im.loading = 'eager'; });
    warm(cur);
  };
  /* At `load`, not on idle: the LCP window is long over, and on a phone the
     main thread can stay busy for seconds after load (tags booting), which
     left frame two cold for a Next pressed a second after landing.

     AND FRAME TWO ALONE WHEN THE HERO FRAME HAS LANDED (2026-10-30, reshaped
     2026-10-31). PostHog, 14 days to 30 Oct: 8 of 16 r45-next rage clicks
     came within 5 s of the pageview, before window load on a phone, so those
     taps found frame two cold. The hero's own load is the moment it stops
     needing the pipe; early() fetches the next frame then without holding
     `load`, and the load-time warm above picks it up from that preload.
     Once only: show() reassigns main.src later. */
  var heroIn = function () { if (!scarce && !busy && document.readyState !== 'complete') early(cur + 1); };
  if (document.readyState === 'complete') setTimeout(warmFirst, 0);
  else {
    addEventListener('load', function () { setTimeout(warmFirst, 0); }, { once: true });
    if (main && main.complete && main.naturalWidth) heroIn();
    else if (main) main.addEventListener('load', heroIn, { once: true });
  }

  var prev = scope.querySelector('[data-r45-prev]');
  var next = scope.querySelector('[data-r45-next]');
  if (prev) prev.addEventListener('click', function () { show(cur - 1); });
  if (next) next.addEventListener('click', function () { show(cur + 1); });

  /* Honour a tap that arrived before this file did. snippets/gallery-preboot-tap
     holds the last arrow or thumbnail press from parse time; the arrows are drawn and look
     alive for seconds while this deferred script waits for the document to
     finish parsing.

     AFTER the two listeners above, never before. Drained first, the replayed
     click landed on a button that still had no handler and was thrown away,
     while the guard marked itself live -- the fix was inert on exactly the five
     resin pages that motivated it. */
  if (typeof window.__ssGalleryDrain === 'function') window.__ssGalleryDrain();

  var photo = scope.querySelector('.r45-photo-main');
  if (photo && thumbs.length > 1) {
    photo.setAttribute('tabindex', '0');
    photo.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(cur - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); show(cur + 1); }
    });
    var x0 = null;
    photo.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    photo.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 42) show(dx < 0 ? cur + 1 : cur - 1);
      x0 = null;
    }, { passive: true });
  }

  /* ── 5 · the two sticky bars ─────────────────────────────────────────────
     One rule, two bars: they appear once the buy button has left through the
     TOP of the viewport. The mobile bar alone also stands in while the button
     has not yet come up from below the fold (see paint(), 2026-09-23).

     WHY THIS IS NOT AN INTERSECTION OBSERVER ANY MORE.
     It was, and the observer got the state wrong twice.

     First, `!entry.isIntersecting` treated "below the fold" and "scrolled past"
     as the same thing. The CTA sits well under a 900px fold on all five of
     these pages, so the very first callback — the one an observer fires the
     moment it starts watching — said not-intersecting and the bar painted
     itself over the announcement strip and the product name on load (Sho,
     2026-08-29: "some kind of bug with Hojari Blend staying on top of the
     product name"). Reading the box's own geometry tells the two
     states apart and fixes that. The test is `bottom < 0`, not `top < 0`, so the
     bar waits until the whole button has left rather than sliding in over the
     top half of a CTA the reader can still see and press.

     Second, and this is why the observer is gone: with `threshold: 0` a
     callback only fires when the intersection RATIO crosses the threshold. An
     element that goes from below the fold to above it without ever being drawn
     — an anchor jump to #reviews, a bfcache restore, End, a deep link — stays
     at ratio 0 the whole way, so no callback fires and the bar never arrives.
     Measured on the preview: stepping down 300px at a time showed the bar;
     jumping straight to y=2400 did not.

     A passive scroll listener coalesced into one rAF is the honest instrument
     for a question about scroll position. It costs one getBoundingClientRect
     per painted frame while the finger is down, it cannot miss a state, and
     `passive: true` keeps it off the scrolling thread's critical path. */
  var panel = scope.querySelector('[data-r45-form]');
  var buybar = document.getElementById('r45-buybar');
  var mobilebar = document.getElementById('r45-mobilebar');
  if (panel && (buybar || mobilebar)) {
    /* The buy area, not #atc itself: sold out, #atc is `hidden` and its box
       measures 0x0 at the top of the viewport, which read as "always on
       screen" and kept both bars away. .r45-buy holds whichever face is
       showing — the button or the sign-up. */
    var watched = scope.querySelector('.r45-buy') || scope.querySelector('#atc') || panel;
    var shown = null, shownMobile = null, ticking = false;

    /* THE MOBILE BAR ALSO STANDS IN WHILE THE BUTTON IS STILL BELOW THE FOLD
       (2026-09-23). The desktop bar keeps the rule above, unchanged: it sits at
       the top, over the announcement strip and the product name, which is what
       Sho saw on 29 Aug. The mobile bar sits at the bottom edge and covers
       neither. On a phone the button is 880px down the page, and paid shoppers
       arrive in the Instagram/Facebook browser with a median 750px viewport
       (PostHog, 9-23 Sep, n=720 myrrh pageviews): the first screen showed a
       photograph with no name, no price and nothing to press, and 26% of paid
       myrrh visits ended before the button ever came into view. The oil pages'
       bar (pdp-atc.js #stickybuy) has worked this way for weeks. It still steps
       aside whenever the real button is on screen, so there are never two. */
    function paint(show, showMobile) {
      if (buybar && show !== shown) {       /* never touch the DOM for nothing */
        buybar.classList.toggle('show', show);
        /* Both bars sit in the layout translated off-screen rather than
           removed, so their buttons are invisible and focusable. They start at
           tabindex -1 from the server and join the tab order only while they
           are actually on screen. */
        /* Every button: a bar carries an add and a notify, one of them hidden. */
        [].forEach.call(buybar.querySelectorAll('button'), function (bb) { bb.tabIndex = show ? 0 : -1; });
      }
      shown = show;
      if (mobilebar && showMobile !== shownMobile) {
        mobilebar.classList.toggle('show', showMobile);
        mobilebar.setAttribute('aria-hidden', showMobile ? 'false' : 'true');
        [].forEach.call(mobilebar.querySelectorAll('button'), function (b) { b.tabIndex = showMobile ? 0 : -1; });
      }
      shownMobile = showMobile;
    }

    /* The site header is `position: sticky; top: 0` at z-index 9999, and the
       theme hides it on scroll down and brings it back on scroll up by moving
       its own `top`. No class changes when it does, and the transform stays
       `none`, so there is nothing to key CSS off — the only honest instrument
       is the rectangle itself. Its bottom edge reads 0 while it is away and its
       full height while it is shown, which is exactly the offset the bar wants.
       Clamped to its own height so the taller unstuck header at the top of the
       page (bottom 118) cannot push the bar down; the bar is not shown there
       anyway. Written only on change, so a scroll that moves nothing touches no
       style. */
    var siteHeader = document.querySelector('sticky-header, .custom-header, .header-wrapper');
    var barTop = null, settling = false, stable = 0;

    function headerBottom() {
      var r = siteHeader.getBoundingClientRect();
      return Math.round(Math.max(0, Math.min(r.bottom, r.height)));
    }
    function applyBarTop() {
      var t = headerBottom();
      if (t === barTop) return false;
      barTop = t;
      buybar.style.setProperty('--r45-bar-top', t + 'px');
      return true;
    }
    /* Sampling on scroll alone is not enough, and this is the part that caught
       me out: the header does not snap back, it eases in over about 250ms —
       measured 31, 53, 60, 64, 65 — and not one scroll event fires while it
       travels. Reading the rectangle from the scroll handler therefore catches
       it at 0 and never looks again, which is exactly what the first attempt
       did. There is nothing to listen for either: the movement is not a `top`
       transition on this element (its only transitions are background-color,
       backdrop-filter and box-shadow), so `transitionend` never arrives.
       So: a short rAF chain that follows the header until its position has held
       still for four frames, then stops. It costs one rectangle read per frame
       while something is actually moving and nothing at all when it is not. */
    function settle() {
      if (applyBarTop()) stable = 0; else stable++;
      if (stable < 4) requestAnimationFrame(settle);
      else settling = false;
    }
    function syncBarTop() {
      if (!buybar || !siteHeader) return;
      applyBarTop();
      if (!settling) { settling = true; stable = 0; requestAnimationFrame(settle); }
    }

    function sync() {
      ticking = false;
      var r = watched.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      /* Below the fold, only a bar that can actually act stands in: a greyed
         sold-out bar on the first screen says nothing the page does not. Sold
         out, the bar's action is the sign-up, so it stands in too. */
      var mbBtn = mobilebar && mobilebar.querySelector('[data-sticky-add]');
      var canAdd = scope.classList.contains('r45--soldout') || !(mbBtn && mbBtn.disabled);
      paint(r.bottom < 0, r.bottom < 0 || (r.top >= vh && canAdd));
      syncBarTop();
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(sync);
    }

    /* The bar's own button is a keyboard stop the moment it is off screen, so
       it starts out of the tab order and joins it only when it is visible. */
    if (mobilebar) {
      [].forEach.call(mobilebar.querySelectorAll('button'), function (mb) { mb.tabIndex = -1; });
    }
    sync();
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll, { passive: true });
    /* A back-navigation restores the scroll position after the parser has run,
       so the state has to be taken again once the page is shown. */
    addEventListener('pageshow', sync);
    /* Two re-reads with no scroll behind them (review, 2026-09-23): a pack switch
       that greys or frees the bar's button while the real one is still below the
       fold, and the layout settling once fonts, images and the in-app toolbar
       have landed. Without them the bar kept its last state until the next scroll. */
    /* Its own name. This was `var barAdd`, which in one function scope is the
       SAME variable as the desktop bar's button at the top of the file: from
       here on paintBar() and syncSoldOut() were repainting and hiding the
       mobile button, and a mid-visit sellout at 1280 px left the desktop bar
       showing a live add beside its notify (review of #3020). */
    var mobBarAdd = mobilebar && mobilebar.querySelector('[data-sticky-add]');
    if (mobBarAdd) new MutationObserver(onScroll).observe(mobBarAdd, { attributes: true, attributeFilter: ['disabled', 'hidden'] });
    addEventListener('load', onScroll);
  }
})();

/* ── 6 · we don't deliver there (2026-10-10) ───────────────────────────────
   A third of the visitors ChatGPT sends live where we have no market: Oman, the
   UAE, Norway, Ukraine. Shopify serves them the backup market, the UK, so the
   server-rendered delivery line promised them a UK arrival date and a UK rate,
   and checkout refused them at the last step (four reached it in six weeks).

   Liquid cannot tell: it sees GB. The browser can. Shopify's edge names the
   visitor's real country in the page's Server-Timing header (country;desc="OM"),
   per request and never cached, the signal snippets/locale-auto-detect already
   reads. When that country is not one we sell to (data-ships-to: every country
   in every market), the delivery line says so plainly and links the shipping
   page instead of promising an arrival.

   English pages only: the other four languages wait for Sho to approve their
   sentence. No header (older Safari, a proxy) or a country we sell to, and the
   page stays exactly as the server rendered it. This touches no money path. */
(function () {
  function noShipCountry(geo, shipsTo) {
    var cc = String(geo || '').toUpperCase();
    if (!/^[A-Z]{2}$/.test(cc)) return '';
    var list = String(shipsTo || '').toUpperCase().split(/\s+/).filter(Boolean);
    if (!list.length) return '';
    return list.indexOf(cc) === -1 ? cc : '';
  }
  /* Countries whose English name takes "the" in a sentence ("to the United
     Arab Emirates"). Only countries we do not sell to can reach this line. */
  var THE = ' AE BS CD CF CG DO FK FO GM KM KY MH MV PH SB TC VA VG VI ';
  /* '' when the code is not a real region (XX, ZZ): better no line than
     "We don't deliver to Unknown Region yet". */
  function countryName(cc) {
    var name = '';
    try { name = new Intl.DisplayNames(['en'], { type: 'region', fallback: 'none' }).of(cc) || ''; } catch (e) { return ''; }
    if (!name || name === cc || /unknown/i.test(name)) return '';
    return (THE.indexOf(' ' + cc + ' ') !== -1 ? 'the ' : '') + name;
  }
  function apply(root, geo) {
    var lang = String(document.documentElement.getAttribute('lang') || 'en').toLowerCase().split('-')[0];
    if (lang !== 'en') return '';
    var cc = noShipCountry(geo, root.getAttribute('data-ships-to'));
    if (!cc) return '';
    var name = countryName(cc);
    if (!name) return '';
    var line = root.querySelector('.r45-ship');
    if (!line) return '';
    /* The estimate script must not write a date back into the line. */
    var est = line.querySelector('[data-delivery-estimate]');
    if (est) est.removeAttribute('data-delivery-estimate');
    line.textContent = '';
    line.appendChild(document.createTextNode('We don’t deliver to ' + name + ' yet. '));
    var a = document.createElement('a');
    a.setAttribute('href', root.getAttribute('data-shipping-url') || '/pages/shipping');
    a.textContent = 'Where we ship';
    line.appendChild(a);
    line.appendChild(document.createTextNode('.'));
    line.setAttribute('data-noship', cc);
    return cc;
  }
  /* A visitor who picked a country by hand in our switcher (ss-market-route.js writes
     ss_mkt_chosen=1 on both sides of the move) has told us where the parcel goes.
     If that country is one we ship to, the page is already priced and dated for it:
     someone in Oman sending a gift to Switzerland must not read "We don't deliver to
     Oman yet" (found in a live browser check, 2026-10-20). Shopify's own localization
     cookie cannot say this, since it is set on every visit. The marker is also written
     by a language-only pick; that visitor sees the plain dated line, which is how every
     page behaved before this section existed, and checkout still refuses an address we
     cannot reach. */
  function chosenDestination(cookieStr, shopCountry, shipsTo, search) {
    /* On the first page after a pick the marker may not be written yet: ss-market-route.js
       loads async and sets it from ?ss_pick=1, then strips that from the address. Whichever
       script runs first, one of the two is present. */
    var picked = /(?:^|;\s*)ss_mkt_chosen=1(?:;|$)/.test(String(cookieStr || ''))
      || /[?&]ss_pick=1(?:&|$)/.test(String(search || ''));
    if (!picked) return false;
    var cc = String(shopCountry || '').toUpperCase();
    return /^[A-Z]{2}$/.test(cc) && !noShipCountry(cc, shipsTo);
  }
  if (globalThis.__R45_NOSHIP_TEST) globalThis.R45NoShip = { noShipCountry: noShipCountry, countryName: countryName, apply: apply, chosenDestination: chosenDestination };
  var root = document.querySelector('.r45[data-ships-to]');
  if (!root) return;
  try {
    if (chosenDestination(document.cookie, window.Shopify && window.Shopify.country, root.getAttribute('data-ships-to'), location.search)) return;
  } catch (e) { /* unreadable cookie: fall through to the geo check */ }
  var geo = '';
  try {
    var nav = performance.getEntriesByType('navigation')[0];
    var st = (nav && nav.serverTiming) || [];
    for (var i = 0; i < st.length; i++) if (st[i].name === 'country') geo = st[i].description;
  } catch (e) { return; }
  var shown = apply(root, geo);
  if (shown) {
    try { if (window.posthog && window.posthog.capture) window.posthog.capture('ss_noship_shown', { country: shown }); } catch (e) { /* analytics never blocks */ }
  }
})();
